import { tencentDocOpenUrlForAll } from '@tencent/tencent_doc_open_url';
import { preprocessUrlOption } from '@tencent/tencent_doc_open_url/dist/cjs/interface';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

declare module '@tencent/tencent_doc_open_url' {
    /**
     * @deprecated 请使用 @src/slide/infrastructure/module/independent/url/open-url 的封装的函数代替
     */
    export function tencentDocOpenUrlForAll(options: preprocessUrlOption): void;
}

const defaultOptions: Partial<preprocessUrlOption> = {};

/**
 *
 * @param options
 * @param options.url 要打开的 url，比如 https://docs.qq.com/sheet/xxx 这样，支持自动识别详情页，打开 detail 容器，支持自动补充 https 头
 * @param options.wxUrl 指定小程序页面 url （参数要调用方组织好），比如 /pages/xxx/xxx?a=1&b=2 注意参数是否需要编码
 * @param options.replace 是否在当前页打开。true 代表是在当前页打开
 * @param options.ignoreDomainDetect 忽略域名校验。默认是要通过 scenario 校验域名的
 * @param options.windowName?: string window.open 第二个参数
 * @param options.windowFeatures?: string window.open 第三个参数
 * @param options.noUserIndex?: boolean 是否需要带u
 * @param options.noHistory?: boolean 是否要清history
 * @param options.useNewConfig?: boolean qq接口的参数
 * @param options.supportIFrame?: boolean 是否兼容 iframe 情况, 如果是 true，则支持 iframe 嵌套，会优先使用 window.top 及其 mqq 和  wx 对象
 * @param options.safariNeedReplace?: boolean safari 强制在当前页面刷新
 * @param options.appConfig?: app 中 openUrl相关的配置
 * @param withDefaults 是否使用全局默认参数
 */
export function openUrlForAll(options: preprocessUrlOption, withDefaults = true): void {
    const opts = withDefaults
        ? {
            ...defaultOptions,
            ...options,
        }
        : options;

    if (getCacConfigByKey('custom.common.multipleDomains', false)) {
        patchUrlForMultipleDomains(opts);
    }

    // 此处封装了原始的 tencentDocOpenUrlForAll 方法，以此实现在不同的端上统一控制异化逻辑
    return tencentDocOpenUrlForAll(opts);
}

/**
 * 设置 tencentDocOpenUrlForAll 的默认参数
 */
export function setDefaultOpenUrlOptions(options: Partial<preprocessUrlOption>) {
    // 打印下设置的默认参数，方便调试和线上定位问题
    window.log?.info('[independent/open-url]', 'set options', options);
    Object.assign(defaultOptions, options);
}

/**
 * 给 URL 打补丁
 */
function patchUrlForMultipleDomains(opts: preprocessUrlOption) {
    if (!opts.url) return;

    // 多域名校验
    const multipleDomainsRegex = /^(\/[a-zA-Z0-9\-_]+)+\/?(?:\?[a-zA-Z0-9\-_&=]*)?$/;
    if (multipleDomainsRegex.test(opts.url)) {
        // eslint-disable-next-line no-param-reassign
        opts.url = `${location.protocol}//${location.hostname}${opts.url}`;
    }
}
